import DeleteIcon from '@material-ui/icons/Delete'
import FolderIcon from '@material-ui/icons/Folder'
import GetAppIcon from '@material-ui/icons/GetApp'
// import useStyles from './ReportsIndexTableOverlay.styles'
import ReportsTableOverlay from 'modules/reports/components/Table/Overlay'
import ReportsTableOverlayButton from 'modules/reports/components/Table/Overlay/Button'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import {useBagContext} from 'modules/reports/contexts/bag'
import useModal from 'modules/reports/hooks/modal'
import useDialog from 'modules/reports/hooks/dialog'
import ReportsDownloadModal from 'modules/reports/modals/Download'

type Props = {}

function ReportsIndexTableOverlay(props: Props) {
  // const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'IndexTableOverlay')
  const bagContext = useBagContext()
  const modal = useModal()
  const dialog = useDialog()

  function handleAddTo() {
    alert('Add to')
  }

  function handleDownload() {
    modal.open(ReportsDownloadModal, {reports: bagContext.items})
  }

  async function handleDelete() {
    const confirmed = await dialog.confirm(pt('confirm-delete', {count: bagContext.items.length}))
    if (confirmed) alert('Delete confirmed')
  }

  return (
    <ReportsTableOverlay data-testid={p()}>
      <ReportsTableOverlayButton
        onClick={handleAddTo}
        icon={<FolderIcon />}
        label={pt('add-to')}
        data-testid={p('add-to')}
      />

      <ReportsTableOverlayButton
        onClick={handleDownload}
        icon={<GetAppIcon />}
        label={pt('download')}
        data-testid={p('download')}
      />
      <ReportsTableOverlayButton
        onClick={handleDelete}
        icon={<DeleteIcon />}
        label={pt('delete')}
        danger
        data-testid={p('delete')}
      />
    </ReportsTableOverlay>
  )
}

export default ReportsIndexTableOverlay
